
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12764',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12764",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.482",
  "data-fetching-client": "static-1.9787",
  "foundations-components": "static-1.8184",
  "foundations-components-legacy": "static-1.1209",
  "foundations-theming": "static-1.4558",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8145",
  "hub-http-shared-msw-handlers": "static-1.10273",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11596",
  "I18n": "static-7.1640",
  "jasmine-runner": "static-1.6583",
  "marketplace-storefront-base": "static-1.12827",
  "quartz": "static-1.7193",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16809",
  "reactive-variable-buffer-atom": "static-1.2982",
  "reporting-testing-lib": "static-1.9997",
  "settings-ui-lib": "static-1.12647",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7368",
  "ui-addon-i18n": "static-1.11274",
  "ui-addon-react-router-dom": "static-1.9662",
  "unified-auth": "static-1.643",
  "unified-auth-core-lib": "static-1.925",
  "usage-tracker": "static-1.7476",
  "usage-tracker-core": "static-1.7326",
  "customer-data-property-utils": "static-1.8220",
  "hub-http": "static-1.6348",
  "integrations-lib": "static-1.16544",
  "marketplace-ui-common": "static-1.20176",
  "property-management-iframe": "static-1.13577",
  "quartz-config": "static-1.971",
  "quartz-core": "static-1.6412",
  "quartz-routing": "static-1.623",
  "quick-fetch": "static-1.4010",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4782",
  "ts-schema": "static-1.4174",
  "ui-universal-auth": "static-1.9129",
  "UIComponents": "static-3.8542",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3492",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3470",
  "quartz-webpack": "static-1.3417",
  "bend-plugin-quartz-routing": "static-1.271",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4453",
  "floating-ui": "static-1.58",
  "foundations-assets": "static-1.4999",
  "foundations-theming-specialty": "static-1.2274",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9549",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.38",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5434",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2207",
  "ui-fonts": "static-1.858",
  "ui-images": "static-2.1185",
  "bend-plugin-foundations-theming": "static-1.3041",
  "foundations-theming-base": "static-1.3543",
  "stylex": "static-1.35",
  "HeadJS": "static-2.772",
  "hs-test-utils-bend-plugin": "static-1.3256",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4451",
  "ai-components-ui-library": "static-1.9271",
  "ai-rendering-library": "static-1.10616",
  "chirp-fetch": "static-1.2013",
  "connections-embed-lib": "static-1.1231",
  "copilot-toolkit": "static-1.11454",
  "feedback-loader": "static-1.29534",
  "laboratory-lib": "static-3.7278",
  "marketplace-embed": "static-1.22473",
  "marketplace-ui-details": "static-1.10071",
  "marketplace-ui-reviews": "static-1.20131",
  "marketplace-ui-tracking": "static-1.14346",
  "sanitize-text": "static-1.8272",
  "ui-addon-video-player": "static-1.8830",
  "usage-tracker-multi": "static-1.5890",
  "usage-tracker-session-replay": "static-1.5162",
  "wootric-nps": "static-1.7075",
  "quartz-head": "static-1.858",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4777",
  "immer": "static-1.33",
  "immerable": "static-1.4275",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2576",
  "reporting-data": "static-1.68064",
  "cssUtils": "static-1.827",
  "flux-actions": "static-1.347",
  "HubStyle": "static-2.11903",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10333",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10487",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7466",
  "icons": "static-2.655",
  "marketplace-ui-apps-core": "static-1.18708",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4636",
  "foundations-components-test-utils": "static-1.5667",
  "quartz-i18n": "static-1.868",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.37",
  "ads-unified-auth-lib": "static-1.409",
  "google-sheets-integration-lib": "static-1.600",
  "microsoft-drive-integration-lib": "static-1.746",
  "surveymonkey-integration-lib": "static-1.55",
  "slack-ui-library": "static-1.10522",
  "fsm": "static-1.3856",
  "customer-data-objects": "static-1.7804",
  "property-translator": "static-1.5522",
  "hs-locale-management": "static-1.174",
  "frontend-preferences-client": "static-1.8052",
  "hs-promise-utils": "static-1.5718",
  "hubspot-apollo-client": "static-1.5003",
  "integrations-error-boundary-lib": "static-1.13959",
  "integrations-tracking-lib": "static-1.5732",
  "native-integrations-shared-strings": "static-1.7907",
  "reselect": "static-2.16",
  "sanitize": "static-1.4602",
  "superstore": "static-1.4885",
  "ui-shepherd-react": "static-3.10379",
  "ai-settings-ui-library": "static-1.8090",
  "hub-http-janus": "static-1.847",
  "hubspotter-http": "static-1.4743",
  "immutable-less": "static-1.4778",
  "marketplace-ui-client-types": "static-1.17583",
  "nav-meta": "static-1.29951",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18165",
  "inbound-db-properties-service-client": "static-1.3939",
  "property-management-common": "static-1.5865",
  "ui-addon-iframeable": "static-1.9192",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.546",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.868",
  "quartz-test": "static-1.868",
  "quartz-tracking": "static-1.572",
  "trellis-components": "static-1.2226",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.192",
  "bender-build-tools": "static-1.3297",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21899",
  "ContentUtils": "static-1.68729",
  "customer-data-objects-ui-components": "static-1.13154",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2624",
  "breeze-engine-core": "static-1.425",
  "breeze-onboarding-components": "static-1.275",
  "customer-data-filters-ui": "static-1.40228",
  "customer-data-reference-ui-components": "static-1.13300",
  "embedded-academy-lib": "static-1.14777",
  "ExportDialog": "static-6.10505",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41617",
  "reporting-snowflake": "static-1.56682",
  "reporting-ui-components": "static-2.65335",
  "reporting-visualizations": "static-1.60140",
  "trellis-theming": "static-1.1066",
  "ui-addon-teams": "static-1.21713",
  "integrations-reconnect-lib": "static-1.204",
  "magpie-lib": "static-1.5635",
  "navigation-components": "static-1.18314",
  "breeze-engine-lib": "static-1.1147",
  "magpie-types": "static-1.5095",
  "simple-logging-lib": "static-1.3174",
  "ai-studio-lib": "static-1.11979",
  "app-governance-lib": "static-1.1941",
  "developer-experience-shared-components": "static-1.10648",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8134",
  "ui-product-approvals": "static-1.28646",
  "ui-tool-access": "static-1.10275",
  "usage-based-billing-components-lib": "static-1.9457",
  "usage-tracker-anonymous": "static-1.5893",
  "usage-tracker-public": "static-1.7287",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3679",
  "persist-promise": "static-1.3826",
  "reference-resolvers": "static-1.8301",
  "ui-extensibility-client-types": "static-1.4049",
  "hubspot-apollo-cache": "static-1.462",
  "universal-page-editor-lib": "static-1.3137",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3123",
  "atom": "static-1.5201",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6105",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1669",
  "crm-component-utils": "static-1.39403",
  "crm-properties-common-lib": "static-1.6015",
  "customer-data-properties": "static-1.51988",
  "framework-data-schema-resolvers": "static-1.7019",
  "property-value-citations": "static-1.2602",
  "reference-resolvers-lite": "static-1.8222",
  "ui-business-units-lib": "static-1.9192",
  "navigation-messaging": "static-1.7641",
  "hubspotter-http-shared-msw-handlers": "static-1.10271",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4940",
  "content-icons-ui": "static-1.2261",
  "customer-data-ui-utilities": "static-1.9950",
  "conversations-skeleton-state": "static-1.7372",
  "crm-message-bus": "static-1.43308",
  "customer-data-filters-ui-msw-helpers": "static-1.22663",
  "events-data-lib": "static-1.359",
  "FormUrlGenerator": "static-2.4847",
  "framework-builder-read-service-client": "static-1.4097",
  "framework-data-schema-quick-fetch": "static-1.6924",
  "multi-account-reference-resolvers": "static-1.1107",
  "onboarding-tours": "static-1.16839",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14035",
  "academy-common-lib": "static-1.14237",
  "content-assistance-lib": "static-1.7956",
  "dashboard-lib": "static-1.82008",
  "file-manager-components": "static-1.23969",
  "getting-started-shared-tasks": "static-1.18754",
  "hubspot-prosemirror": "static-1.18590",
  "hubspot-prosemirror-plugins": "static-1.18582",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20051",
  "share-with-third-party-component-lib": "static-1.8829",
  "ui-addon-draggable": "static-3.4885",
  "ui-asset-management-lib": "static-1.11194",
  "user-context": "static-1.5234",
  "growth-payments-core": "static-1.25739",
  "reporting-plugins": "static-1.10519",
  "reporting-reports": "static-1.67742",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.851",
  "nest": "static-1.358",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10753",
  "framework-listing-lib": "static-2.29039",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30994",
  "apps-service-types": "static-1.3926",
  "oauth-service-types": "static-1.4379",
  "react-dnd-compat": "static-1.4740",
  "ui-product-approvals-common": "static-1.541",
  "onboarding-scopes": "static-1.6586",
  "onboarding-tours-client": "static-1.5053",
  "platform-infra-nav-components": "static-1.7766",
  "subscription-experience-data-types": "static-1.15075",
  "crm-record-cards-service-types": "static-1.3678",
  "location-customization-utils-lib": "static-1.9613",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6108",
  "signup-constants": "static-1.19163",
  "signup-ui-url-generator": "static-2.8183",
  "card-properties-lib": "static-1.44561",
  "commerce-subscription-lib": "static-1.37431",
  "crm-actions": "static-1.6464",
  "crm-cards-sdk": "static-1.43959",
  "customer-data-properties-shared-msw-handlers": "static-1.9600",
  "customer-data-tracking": "static-1.7012",
  "hs-resources": "static-1.301",
  "pulse": "static-1.729",
  "calling-global-api": "static-1.64931",
  "calling-internal-common": "static-1.31436",
  "calling-lifecycle-internal": "static-1.66313",
  "calling-lifecycle-messages": "static-1.58607",
  "commerce-products-lib": "static-1.10025",
  "conditional-properties-service-client": "static-1.3890",
  "crm-links": "static-1.6434",
  "crm-pipelines-api-client-types": "static-1.4229",
  "external-options-client-types": "static-1.4219",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4310",
  "meetings-icalendar-utils-lib": "static-1.758",
  "multi-currency-client-types": "static-1.3783",
  "object-builder-ui-client": "static-1.49168",
  "pipeline-validation-client-types": "static-1.4058",
  "smart-property-lib": "static-1.7884",
  "tiered-pricing": "static-1.1545",
  "ui-addon-form-validation": "static-1.11116",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.138",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1191",
  "growth-data-modal": "static-1.5633",
  "growth-onboarding-confetti": "static-1.3191",
  "growth-onboarding-next-action-utils": "static-1.2270",
  "onboarding-tours-utils": "static-1.905",
  "ui-shepherd-tracker": "static-1.7760",
  "academy-service-client": "static-1.3809",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39468",
  "FileManagerLib": "static-1.39609",
  "SafeStorage": "static-1.4525",
  "video-embed": "static-1.36171",
  "ui-coaching-tips": "static-1.28902",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11679",
  "video-data-lib": "static-1.35337",
  "content-media-capture": "static-1.4889",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23837",
  "ui-addon-emoji-picker": "static-1.10012",
  "EmailSignatureEditor": "static-1.24647",
  "viral-links-lib": "static-1.7195",
  "data-token-picker": "static-1.16633",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.359",
  "timezone-utils": "static-2.5368",
  "seat-types-lib": "static-1.288",
  "getting-started-shared-tasks-store": "static-1.17872",
  "ui-addon-opt": "static-4.8487",
  "campaign-roi-lib": "static-1.9465",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25699",
  "framework-data-table": "static-2.12199",
  "marketing-platform-lib": "static-1.6991",
  "nudge-client-utils": "static-1.2849",
  "nudge-custom-ui-functions": "static-1.1248",
  "switchboard-lib": "static-1.350",
  "app-users-service-client": "static-1.5734",
  "app-users-service-types": "static-1.5142",
  "mini-checkout-client": "static-1.27110",
  "onboarding-utils": "static-1.5484",
  "permissions-shared-i18n-strings-fe": "static-1.2062",
  "ui-coaching-tips-shared-config": "static-1.28887",
  "edison-service-client-types": "static-1.514",
  "crm_data": "static-4.92354",
  "customer-data-sidebar": "static-2.46357",
  "enrichment-properties-lib": "static-1.17002",
  "ui-addon-draggable-compat": "static-2.4385",
  "universal-record-utils-lib": "static-1.1272",
  "commerce-billing-lib": "static-1.19499",
  "commerce-shared-components-lib": "static-1.18850",
  "commerce-tools-ui-lib": "static-1.10706",
  "crm-fe-perf": "static-1.23027",
  "event-emitter": "static-1.1075",
  "bend-plugin-pulse": "static-1.232",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31443",
  "shared-worker-versioning": "static-1.11161",
  "calling-usage-tracker": "static-1.6669",
  "voice-sms-access-library": "static-1.1461",
  "commerce-permissions": "static-1.901",
  "products-iframe-lib": "static-1.8273",
  "products-ui-components-shared-msw-handlers": "static-1.10655",
  "data-agent-kit": "static-1.405",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10356",
  "policy-lib": "static-1.6911",
  "react-tinymce": "static-1.55571",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10419",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54697",
  "tinymce-plugins": "static-1.57811",
  "tinymce-themes": "static-1.56667",
  "onboarding-data-sync-lib": "static-1.2182",
  "growth-onboarding-next-action-components": "static-1.2298",
  "user-context-client": "static-1.4705",
  "audio-components": "static-1.6112",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37120",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4661",
  "video-components": "static-1.13681",
  "outpost": "static-1.4293",
  "growth-onboarding-feedback-components": "static-1.6704",
  "content-media-composition-data-lib": "static-1.12693",
  "content-media-compositions": "static-2.16700",
  "media-bridge-lib": "static-1.19146",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4551",
  "commerce-tours-lib": "static-1.6330",
  "growth-onboarding-reliability": "static-1.5207",
  "sales-checkout-service-client": "static-1.3718",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21899",
  "sales-email-signature-service-client": "static-1.3975",
  "ts-utils-lib": "static-1.299",
  "crm-export-dialog": "static-1.6410",
  "crm-index-associations-lib": "static-1.6566",
  "crm-view-components": "static-1.647",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7457",
  "nudge-custom-function-registry": "static-1.2606",
  "nudge-renderer-utils": "static-1.2925",
  "whisper-core-api": "static-1.6885",
  "InboxConnectUtils": "static-4.15138",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5821",
  "settings-content-modals": "static-1.46432",
  "crm_universal": "static-1.22233",
  "customer-data-email": "static-1.18260",
  "card-payment-highlight-lib": "static-1.37524",
  "card-subscription-highlight-lib": "static-1.39854",
  "commerce-contract-lib": "static-1.12650",
  "invoices-highlight-card-lib": "static-1.55130",
  "orders-highlight-card-lib": "static-1.21803",
  "products-highlight-card-lib": "static-1.18308",
  "quotes-highlight-card-lib": "static-1.72431",
  "crm-source-interpretation-lib": "static-1.5461",
  "crm-object-search-query-utilities": "static-1.9862",
  "utility-belt": "static-1.2657",
  "payments-enrollment-embed-lib": "static-1.23284",
  "stripe-embedded-components": "static-1.7733",
  "customer-data-rte": "static-1.33318",
  "cv-backend-services": "static-1.1568",
  "growth-onboarding-empty-states": "static-1.5976",
  "payments-post-enroll-local-storage-lib": "static-1.5232",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38521",
  "trials-service-types": "static-1.4008",
  "calling-orchestration-schema": "static-1.36238",
  "sales-views-client-types": "static-1.4382",
  "hub-http-contrib": "static-1.3168",
  "interframe": "static-3.4885",
  "tinymce-data": "static-1.40782",
  "ui-addon-sales-email": "static-1.5336",
  "layout-dnd-components": "static-1.12690",
  "layout-dnd-utils": "static-1.11665",
  "ui-brand-identity-lib": "static-1.15726",
  "NamespacedHubStyle": "static-2.9146",
  "meetings-connect-utils-lib": "static-1.7730",
  "social-insights-client-types": "static-1.22366",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4300",
  "checkout-sdk": "static-3.23953",
  "company-details-components": "static-1.6323",
  "payment-method-components": "static-1.6995",
  "pricing-pages-ui-components": "static-1.14750",
  "quote-checkout-service-types": "static-1.3590",
  "upgrade-catalog-service-types": "static-1.3647",
  "access-control-lib": "static-1.10562",
  "EmailComponents": "static-1.55115",
  "EmailData": "static-1.53792",
  "redux-less": "static-2.9607",
  "sequences-lib": "static-1.8255",
  "ui-gdpr-components": "static-1.10476",
  "products-ui-components": "static-1.40543",
  "accounting-integrations-ui-components": "static-1.7273",
  "invoices-ui-lib": "static-1.55146",
  "commerce-products-api": "static-1.2477",
  "invoices-iframe-lib": "static-1.57204",
  "quotes-modal-lib": "static-1.103109",
  "quotes-ui-lib": "static-1.81152",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28584",
  "ContentData": "static-1.68804",
  "layout-data-lib": "static-1.9990",
  "checkout-service-types": "static-1.3889",
  "hub-http-rxjs": "static-1.813",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4062",
  "billing-payments-client-types": "static-1.4115",
  "react-performance-metrics-lib": "static-1.682",
  "pricing-pages-api": "static-1.14615",
  "ContentComponents": "static-2.71685",
  "marketing-contacts-lib": "static-1.10449",
  "marketing-email-service-types": "static-1.1995",
  "messaging-editing-lib": "static-1.46632",
  "messaging-usage-based-billing-components-lib": "static-1.1494",
  "automation-ui-source-apps": "static-1.19241",
  "automation-ui-types": "static-1.20159",
  "messaging-types-lib": "static-1.46369",
  "onboarding-settings-client": "static-1.4630",
  "sequences-client-types-lib": "static-1.8112",
  "commerce-tax-lib": "static-1.661",
  "price-books-api": "static-1.1267",
  "price-books-components": "static-1.1325",
  "property-description-translator": "static-1.3966",
  "ramp-editor": "static-1.479",
  "commerce-analytics-service-client": "static-1.3706",
  "totals-ui-components": "static-1.23933",
  "SalesContentIndexUI": "static-3.9418",
  "advanced-menus-core": "static-1.15339",
  "advanced-menus-lib": "static-1.12250",
  "ui-memberships-settings-lib": "static-1.34373",
  "segments-query-core": "static-1.1545",
  "automation-ui-ubb": "static-1.6075",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7463",
  "data-token-views": "static-1.16614",
  "forms-utils-lib": "static-1.12820",
  "payments-embed-points-lib": "static-1.13290",
  "simple-menus-core": "static-1.15338",
  "simple-menus-lib": "static-1.16855",
  "videoconference-integration-components": "static-1.7015",
  "mc-hard-limits-client-types": "static-1.24",
  "marketing-contacts-client": "static-1.7637",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77447",
  "short-messages-app-service-client": "static-1.4048",
  "web-interactives-components": "static-1.13984",
  "web-interactives-data": "static-1.13985",
  "messaging-shared-utils-lib": "static-1.943",
  "messaging-user-info-utils-lib": "static-1.1113",
  "email-portal-health-service-types": "static-1.1102",
  "line-items-api": "static-1.875",
  "commerce-totals-service-types": "static-1.3910",
  "FireAlarmUi": "static-1.4600",
  "sales-templates-service-types-lib": "static-1.4261",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22095",
  "automation-ui-usage-tracking": "static-1.21558",
  "data-studio-ubb": "static-1.3079",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27304",
  "collaboration-sidebar": "static-1.58211",
  "content-management-data-lib": "static-1.5628",
  "copilot-plugins": "static-1.11427",
  "cta-picker": "static-1.36723",
  "customer-agent-discovery-components-lib": "static-1.3437",
  "editor-components": "static-1.13415",
  "editor-iframe-lib": "static-1.8581",
  "error-messaging-js": "static-1.5319",
  "FormsCommonComponents": "static-1.86150",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10771",
  "SharedLegalStrings": "static-1.1870",
  "smart-content-core": "static-1.42780",
  "smart-content-lib": "static-1.43433",
  "social-composer-lib": "static-1.59590",
  "structured-content-lib": "static-1.25521",
  "theme-previewer-lib": "static-1.53580",
  "tinymce-copilot": "static-1.16765",
  "xray-recommendation-lib": "static-1.8067",
  "automation-ui-routing": "static-1.21516",
  "sql-reporting-client-types": "static-1.5740",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42464",
  "campaigns-utils-lib": "static-1.3319",
  "reporting-enablement": "static-1.23341",
  "chatspot-widget-iframe": "static-1.21890",
  "collaboration-sidebar-common": "static-1.3008",
  "forms-ai-lib": "static-1.4518",
  "codemirror-dlb": "static-1.59006",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6560",
  "report-customization-components": "static-1.13507",
  "data-quality-ui-library": "static-1.13355",
  "reporting-filters": "static-1.630",
  "reporting-insights-lib": "static-1.2105"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12764",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.482",
  "data-fetching-client": "/data-fetching-client/static-1.9787",
  "foundations-components": "/foundations-components/static-1.8184",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1209",
  "foundations-theming": "/foundations-theming/static-1.4558",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8145",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10273",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11596",
  "I18n": "/I18n/static-7.1640",
  "jasmine-runner": "/jasmine-runner/static-1.6583",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12827",
  "quartz": "/quartz/static-1.7193",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16809",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2982",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9997",
  "settings-ui-lib": "/settings-ui-lib/static-1.12647",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7368",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11274",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9662",
  "unified-auth": "/unified-auth/static-1.643",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.925",
  "usage-tracker": "/usage-tracker/static-1.7476",
  "usage-tracker-core": "/usage-tracker-core/static-1.7326",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8220",
  "hub-http": "/hub-http/static-1.6348",
  "integrations-lib": "/integrations-lib/static-1.16544",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20176",
  "property-management-iframe": "/property-management-iframe/static-1.13577",
  "quartz-config": "/quartz-config/static-1.971",
  "quartz-core": "/quartz-core/static-1.6412",
  "quartz-routing": "/quartz-routing/static-1.623",
  "quick-fetch": "/quick-fetch/static-1.4010",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4782",
  "ts-schema": "/ts-schema/static-1.4174",
  "ui-universal-auth": "/ui-universal-auth/static-1.9129",
  "UIComponents": "/UIComponents/static-3.8542",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3492",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3470",
  "quartz-webpack": "/quartz-webpack/static-1.3417",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.271",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4453",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4999",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2274",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9549",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.38",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5434",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2207",
  "ui-fonts": "/ui-fonts/static-1.858",
  "ui-images": "/ui-images/static-2.1185",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3041",
  "foundations-theming-base": "/foundations-theming-base/static-1.3543",
  "stylex": "/stylex/static-1.35",
  "HeadJS": "/HeadJS/static-2.772",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3256",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4451",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9271",
  "ai-rendering-library": "/ai-rendering-library/static-1.10616",
  "chirp-fetch": "/chirp-fetch/static-1.2013",
  "connections-embed-lib": "/connections-embed-lib/static-1.1231",
  "copilot-toolkit": "/copilot-toolkit/static-1.11454",
  "feedback-loader": "/feedback-loader/static-1.29534",
  "laboratory-lib": "/laboratory-lib/static-3.7278",
  "marketplace-embed": "/marketplace-embed/static-1.22473",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10071",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20131",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14346",
  "sanitize-text": "/sanitize-text/static-1.8272",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8830",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5890",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5162",
  "wootric-nps": "/wootric-nps/static-1.7075",
  "quartz-head": "/quartz-head/static-1.858",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4777",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4275",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2576",
  "reporting-data": "/reporting-data/static-1.68064",
  "cssUtils": "/cssUtils/static-1.827",
  "flux-actions": "/flux-actions/static-1.347",
  "HubStyle": "/HubStyle/static-2.11903",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10333",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10487",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7466",
  "icons": "/icons/static-2.655",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18708",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4636",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5667",
  "quartz-i18n": "/quartz-i18n/static-1.868",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.37",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.409",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.600",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.746",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.55",
  "slack-ui-library": "/slack-ui-library/static-1.10522",
  "fsm": "/fsm/static-1.3856",
  "customer-data-objects": "/customer-data-objects/static-1.7804",
  "property-translator": "/property-translator/static-1.5522",
  "hs-locale-management": "/hs-locale-management/static-1.174",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8052",
  "hs-promise-utils": "/hs-promise-utils/static-1.5718",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5003",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13959",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5732",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7907",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4602",
  "superstore": "/superstore/static-1.4885",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10379",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8090",
  "hub-http-janus": "/hub-http-janus/static-1.847",
  "hubspotter-http": "/hubspotter-http/static-1.4743",
  "immutable-less": "/immutable-less/static-1.4778",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17583",
  "nav-meta": "/nav-meta/static-1.29951",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18165",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3939",
  "property-management-common": "/property-management-common/static-1.5865",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9192",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.546",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.868",
  "quartz-test": "/quartz-test/static-1.868",
  "quartz-tracking": "/quartz-tracking/static-1.572",
  "trellis-components": "/trellis-components/static-1.2226",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.192",
  "bender-build-tools": "/bender-build-tools/static-1.3297",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21899",
  "ContentUtils": "/ContentUtils/static-1.68729",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13154",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2624",
  "breeze-engine-core": "/breeze-engine-core/static-1.425",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.275",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40228",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13300",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14777",
  "ExportDialog": "/ExportDialog/static-6.10505",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41617",
  "reporting-snowflake": "/reporting-snowflake/static-1.56682",
  "reporting-ui-components": "/reporting-ui-components/static-2.65335",
  "reporting-visualizations": "/reporting-visualizations/static-1.60140",
  "trellis-theming": "/trellis-theming/static-1.1066",
  "ui-addon-teams": "/ui-addon-teams/static-1.21713",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.204",
  "magpie-lib": "/magpie-lib/static-1.5635",
  "navigation-components": "/navigation-components/static-1.18314",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1147",
  "magpie-types": "/magpie-types/static-1.5095",
  "simple-logging-lib": "/simple-logging-lib/static-1.3174",
  "ai-studio-lib": "/ai-studio-lib/static-1.11979",
  "app-governance-lib": "/app-governance-lib/static-1.1941",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10648",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8134",
  "ui-product-approvals": "/ui-product-approvals/static-1.28646",
  "ui-tool-access": "/ui-tool-access/static-1.10275",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9457",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5893",
  "usage-tracker-public": "/usage-tracker-public/static-1.7287",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3679",
  "persist-promise": "/persist-promise/static-1.3826",
  "reference-resolvers": "/reference-resolvers/static-1.8301",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4049",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.462",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3137",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3123",
  "atom": "/atom/static-1.5201",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6105",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1669",
  "crm-component-utils": "/crm-component-utils/static-1.39403",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6015",
  "customer-data-properties": "/customer-data-properties/static-1.51988",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7019",
  "property-value-citations": "/property-value-citations/static-1.2602",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8222",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9192",
  "navigation-messaging": "/navigation-messaging/static-1.7641",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10271",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4940",
  "content-icons-ui": "/content-icons-ui/static-1.2261",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9950",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7372",
  "crm-message-bus": "/crm-message-bus/static-1.43308",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22663",
  "events-data-lib": "/events-data-lib/static-1.359",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4847",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4097",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6924",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1107",
  "onboarding-tours": "/onboarding-tours/static-1.16839",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14035",
  "academy-common-lib": "/academy-common-lib/static-1.14237",
  "content-assistance-lib": "/content-assistance-lib/static-1.7956",
  "dashboard-lib": "/dashboard-lib/static-1.82008",
  "file-manager-components": "/file-manager-components/static-1.23969",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18754",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18590",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18582",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20051",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8829",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4885",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11194",
  "user-context": "/user-context/static-1.5234",
  "growth-payments-core": "/growth-payments-core/static-1.25739",
  "reporting-plugins": "/reporting-plugins/static-1.10519",
  "reporting-reports": "/reporting-reports/static-1.67742",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.851",
  "nest": "/nest/static-1.358",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10753",
  "framework-listing-lib": "/framework-listing-lib/static-2.29039",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30994",
  "apps-service-types": "/apps-service-types/static-1.3926",
  "oauth-service-types": "/oauth-service-types/static-1.4379",
  "react-dnd-compat": "/react-dnd-compat/static-1.4740",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.541",
  "onboarding-scopes": "/onboarding-scopes/static-1.6586",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5053",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7766",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15075",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3678",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9613",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6108",
  "signup-constants": "/signup-constants/static-1.19163",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8183",
  "card-properties-lib": "/card-properties-lib/static-1.44561",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37431",
  "crm-actions": "/crm-actions/static-1.6464",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43959",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9600",
  "customer-data-tracking": "/customer-data-tracking/static-1.7012",
  "hs-resources": "/hs-resources/static-1.301",
  "pulse": "/pulse/static-1.729",
  "calling-global-api": "/calling-global-api/static-1.64931",
  "calling-internal-common": "/calling-internal-common/static-1.31436",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66313",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58607",
  "commerce-products-lib": "/commerce-products-lib/static-1.10025",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3890",
  "crm-links": "/crm-links/static-1.6434",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4229",
  "external-options-client-types": "/external-options-client-types/static-1.4219",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4310",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.758",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3783",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49168",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4058",
  "smart-property-lib": "/smart-property-lib/static-1.7884",
  "tiered-pricing": "/tiered-pricing/static-1.1545",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11116",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.138",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1191",
  "growth-data-modal": "/growth-data-modal/static-1.5633",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3191",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2270",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.905",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7760",
  "academy-service-client": "/academy-service-client/static-1.3809",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39468",
  "FileManagerLib": "/FileManagerLib/static-1.39609",
  "SafeStorage": "/SafeStorage/static-1.4525",
  "video-embed": "/video-embed/static-1.36171",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28902",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11679",
  "video-data-lib": "/video-data-lib/static-1.35337",
  "content-media-capture": "/content-media-capture/static-1.4889",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23837",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10012",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24647",
  "viral-links-lib": "/viral-links-lib/static-1.7195",
  "data-token-picker": "/data-token-picker/static-1.16633",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.359",
  "timezone-utils": "/timezone-utils/static-2.5368",
  "seat-types-lib": "/seat-types-lib/static-1.288",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17872",
  "ui-addon-opt": "/ui-addon-opt/static-4.8487",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9465",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25699",
  "framework-data-table": "/framework-data-table/static-2.12199",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6991",
  "nudge-client-utils": "/nudge-client-utils/static-1.2849",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1248",
  "switchboard-lib": "/switchboard-lib/static-1.350",
  "app-users-service-client": "/app-users-service-client/static-1.5734",
  "app-users-service-types": "/app-users-service-types/static-1.5142",
  "mini-checkout-client": "/mini-checkout-client/static-1.27110",
  "onboarding-utils": "/onboarding-utils/static-1.5484",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2062",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28887",
  "edison-service-client-types": "/edison-service-client-types/static-1.514",
  "crm_data": "/crm_data/static-4.92354",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46357",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17002",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4385",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1272",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19499",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18850",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10706",
  "crm-fe-perf": "/crm-fe-perf/static-1.23027",
  "event-emitter": "/event-emitter/static-1.1075",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.232",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31443",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11161",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6669",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1461",
  "commerce-permissions": "/commerce-permissions/static-1.901",
  "products-iframe-lib": "/products-iframe-lib/static-1.8273",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10655",
  "data-agent-kit": "/data-agent-kit/static-1.405",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10356",
  "policy-lib": "/policy-lib/static-1.6911",
  "react-tinymce": "/react-tinymce/static-1.55571",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10419",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54697",
  "tinymce-plugins": "/tinymce-plugins/static-1.57811",
  "tinymce-themes": "/tinymce-themes/static-1.56667",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2182",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2298",
  "user-context-client": "/user-context-client/static-1.4705",
  "audio-components": "/audio-components/static-1.6112",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37120",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4661",
  "video-components": "/video-components/static-1.13681",
  "outpost": "/outpost/static-1.4293",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6704",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12693",
  "content-media-compositions": "/content-media-compositions/static-2.16700",
  "media-bridge-lib": "/media-bridge-lib/static-1.19146",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4551",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6330",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5207",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3718",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21899",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3975",
  "ts-utils-lib": "/ts-utils-lib/static-1.299",
  "crm-export-dialog": "/crm-export-dialog/static-1.6410",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6566",
  "crm-view-components": "/crm-view-components/static-1.647",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7457",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2606",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2925",
  "whisper-core-api": "/whisper-core-api/static-1.6885",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15138",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5821",
  "settings-content-modals": "/settings-content-modals/static-1.46432",
  "crm_universal": "/crm_universal/static-1.22233",
  "customer-data-email": "/customer-data-email/static-1.18260",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37524",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39854",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12650",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55130",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21803",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18308",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72431",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5461",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9862",
  "utility-belt": "/utility-belt/static-1.2657",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23284",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7733",
  "customer-data-rte": "/customer-data-rte/static-1.33318",
  "cv-backend-services": "/cv-backend-services/static-1.1568",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5976",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5232",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38521",
  "trials-service-types": "/trials-service-types/static-1.4008",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36238",
  "sales-views-client-types": "/sales-views-client-types/static-1.4382",
  "hub-http-contrib": "/hub-http-contrib/static-1.3168",
  "interframe": "/interframe/static-3.4885",
  "tinymce-data": "/tinymce-data/static-1.40782",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5336",
  "layout-dnd-components": "/layout-dnd-components/static-1.12690",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11665",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15726",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9146",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7730",
  "social-insights-client-types": "/social-insights-client-types/static-1.22366",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4300",
  "checkout-sdk": "/checkout-sdk/static-3.23953",
  "company-details-components": "/company-details-components/static-1.6323",
  "payment-method-components": "/payment-method-components/static-1.6995",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14750",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3590",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3647",
  "access-control-lib": "/access-control-lib/static-1.10562",
  "EmailComponents": "/EmailComponents/static-1.55115",
  "EmailData": "/EmailData/static-1.53792",
  "redux-less": "/redux-less/static-2.9607",
  "sequences-lib": "/sequences-lib/static-1.8255",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10476",
  "products-ui-components": "/products-ui-components/static-1.40543",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7273",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55146",
  "commerce-products-api": "/commerce-products-api/static-1.2477",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57204",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103109",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81152",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28584",
  "ContentData": "/ContentData/static-1.68804",
  "layout-data-lib": "/layout-data-lib/static-1.9990",
  "checkout-service-types": "/checkout-service-types/static-1.3889",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.813",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4062",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4115",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.682",
  "pricing-pages-api": "/pricing-pages-api/static-1.14615",
  "ContentComponents": "/ContentComponents/static-2.71685",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10449",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1995",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46632",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1494",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19241",
  "automation-ui-types": "/automation-ui-types/static-1.20159",
  "messaging-types-lib": "/messaging-types-lib/static-1.46369",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4630",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8112",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.661",
  "price-books-api": "/price-books-api/static-1.1267",
  "price-books-components": "/price-books-components/static-1.1325",
  "property-description-translator": "/property-description-translator/static-1.3966",
  "ramp-editor": "/ramp-editor/static-1.479",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3706",
  "totals-ui-components": "/totals-ui-components/static-1.23933",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9418",
  "advanced-menus-core": "/advanced-menus-core/static-1.15339",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12250",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34373",
  "segments-query-core": "/segments-query-core/static-1.1545",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6075",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7463",
  "data-token-views": "/data-token-views/static-1.16614",
  "forms-utils-lib": "/forms-utils-lib/static-1.12820",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13290",
  "simple-menus-core": "/simple-menus-core/static-1.15338",
  "simple-menus-lib": "/simple-menus-lib/static-1.16855",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7015",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.24",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7637",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77447",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4048",
  "web-interactives-components": "/web-interactives-components/static-1.13984",
  "web-interactives-data": "/web-interactives-data/static-1.13985",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.943",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1113",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1102",
  "line-items-api": "/line-items-api/static-1.875",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3910",
  "FireAlarmUi": "/FireAlarmUi/static-1.4600",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4261",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22095",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21558",
  "data-studio-ubb": "/data-studio-ubb/static-1.3079",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27304",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58211",
  "content-management-data-lib": "/content-management-data-lib/static-1.5628",
  "copilot-plugins": "/copilot-plugins/static-1.11427",
  "cta-picker": "/cta-picker/static-1.36723",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3437",
  "editor-components": "/editor-components/static-1.13415",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8581",
  "error-messaging-js": "/error-messaging-js/static-1.5319",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86150",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10771",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1870",
  "smart-content-core": "/smart-content-core/static-1.42780",
  "smart-content-lib": "/smart-content-lib/static-1.43433",
  "social-composer-lib": "/social-composer-lib/static-1.59590",
  "structured-content-lib": "/structured-content-lib/static-1.25521",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53580",
  "tinymce-copilot": "/tinymce-copilot/static-1.16765",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8067",
  "automation-ui-routing": "/automation-ui-routing/static-1.21516",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5740",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42464",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3319",
  "reporting-enablement": "/reporting-enablement/static-1.23341",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21890",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3008",
  "forms-ai-lib": "/forms-ai-lib/static-1.4518",
  "codemirror-dlb": "/codemirror-dlb/static-1.59006",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6560",
  "report-customization-components": "/report-customization-components/static-1.13507",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13355",
  "reporting-filters": "/reporting-filters/static-1.630",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2105"
}
};
